'use client';

import { useState } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface ConsultationCTAProps {
  title: string;
  description: string;
}

const ConsultationCTA = ({ title, description }: ConsultationCTAProps) => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setIsSubmitted(true);
      setTimeout(() => {
        setEmail('');
        setIsSubmitted(false);
      }, 3000);
    }
  };

  return (
    <section className="px-6 lg:px-12 py-24 lg:py-32 bg-primary text-primary-foreground">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-headline font-bold tracking-tight mb-6">
          {title}
        </h2>
        <p className="text-lg lg:text-xl font-body opacity-90 mb-12 max-w-3xl mx-auto">
          {description}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <Link
            href="/contact"
            className="inline-flex items-center gap-2 px-8 py-4 bg-primary-foreground text-primary text-base font-cta font-semibold tracking-wide border border-primary-foreground transition-all duration-fast hover:-translate-y-0.5 hover:shadow-card"
          >
            Schedule Consultation
            <Icon name="ArrowRightIcon" size={20} />
          </Link>

          <a
            href="mailto:hello@boldminimal.com"
            className="inline-flex items-center gap-2 px-8 py-4 bg-transparent text-primary-foreground text-base font-cta font-semibold tracking-wide border border-primary-foreground transition-all duration-fast hover:bg-primary-foreground hover:text-primary"
          >
            <Icon name="EnvelopeIcon" size={20} />
            Email Directly
          </a>
        </div>

        <div className="max-w-md mx-auto">
          <p className="text-sm font-body opacity-80 mb-4">
            Or subscribe to our insights newsletter
          </p>
          <form onSubmit={handleSubmit} className="flex gap-2">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
              className="flex-1 px-4 py-3 bg-primary-foreground text-primary text-sm font-body border border-primary-foreground focus:outline-none focus:ring-2 focus:ring-primary-foreground"
            />
            <button
              type="submit"
              disabled={isSubmitted}
              className="px-6 py-3 bg-primary-foreground text-primary text-sm font-cta font-semibold tracking-wide border border-primary-foreground transition-all duration-fast hover:-translate-y-0.5 hover:shadow-card disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isSubmitted ? 'Subscribed!' : 'Subscribe'}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ConsultationCTA;